<template>
    
    <div>
        <div class="form-group"  v-for="option in filter.inputs.level.options" :key="option.value">
            <label :for="`level-${option.value}`" class="form-label">
                <input type="radio" :id="`level-${option.value}`" v-model="level" :value="option.value"> 
                {{ option.label }}
            </label>
        </div>  

        <div class="form-group ">
            <label for="" class="form-label label-block">{{ filter.inputs.campaigns.label }}</label>
            <div class="form-input m-0 dblock">
                 <label :for="`campaign-${option.value}`" class="form-label label-block" v-for="option in filter.inputs.campaigns.options" :key="option.value">
                    <input type="checkbox" :id="`campaign-${option.value}`" v-model="campaigns" :value="option.value"> 
                    {{ option.label }}
                </label>
            </div>
        </div>
        <div class="form-group">
            <label for="" class="form-label label-block">{{ filter.inputs.consent.label }}</label>
            <div class="form-input">
                <label :for="`${option.value}-consent`" class="form-label label-block" v-for="option in filter.inputs.consent.options" :key="option.value">
                    <input type="radio" :id="`${option.value}-consent`" v-model="consent" :value="option.value"> 
                    {{ option.label }}
                </label>
            </div>
        </div>

        <div class="form-group" v-if="consent == 'with'">
            <label for="" class="form-label">{{ filter.inputs.date.label }}</label>
            <div class="form-input">
                <select name="" id="" v-model="date">
                    <option v-for="option in filter.inputs.date.options" :key="option.value" :value="option.value" v-text="option.label" />
                </select>
            </div>
        </div>
    </div>
</template>

<script>
	import ListingFilterMixin from './ListingFilterMixin.js';

    export default {
        mixins	: [
			ListingFilterMixin
		],
        data(){
            return {
                level : '',
                consent : '',
                campaigns : [],
                date : '',
            }
        },

        computed : {
            data(){
                return {
                    level : this.level,
                    consent : this.consent,
                    campaigns : this.campaigns,
                    date : this.date
                }
            }
        }
    }
</script>
